import Swal from "sweetalert2";

const AlertsPlugin = {
    install(Vue) {
        /**
         * Alerta de confirmación con exito.
         *
         * @param {string} message - Mensaje de la alerta.
         * @param {integer} time - Tiempo de la alerta.
         * @param {string} confirmButton - Botón de confirmación.
         * @param {string} title - Título de la alerta.
         * @returns {Promise<void>}
         * @author Brandon Torres
         */
        Vue.prototype.$alertSuccess = function (
            message,
            time = 2000,
            confirmButton = false,
            title = "¡Muy bien!"
        ) {
            Swal.fire({
                position: "center",
                icon: "success",
                title: title,
                text: message,
                showConfirmButton: confirmButton,
                timer: time,
            });
        };

        /**
         * Alerta de confirmación con error.
         *
         * @param {string} message - Mensaje de la alerta.
         * @param {integer} time - Tiempo de la alerta.
         * @param {string} confirmButton - Botón de confirmación.
         * @param {string} title - Título de la alerta.
         * @returns {Promise<void>}
         * @author Brandon Torres
         */
        Vue.prototype.$alertError = function (
            message,
            time = 2000,
            confirmButton = false,
            title = "¡Error!",
            type = 'error'
        ) {
            Swal.fire({
                position: "center",
                icon: type,
                title: title,
                text: message,
                showConfirmButton: confirmButton,
                timer: time,
            });
        };

        /**
         * Alerta con acciones de callback.
         *
         * @param {string} icon - Icono de la alerta.
         * @param {integer} time - Tiempo de la alerta.
         * @param {boolean} showConfirmButton - Mostrar botón de confirmación.
         * @param {boolean} showCancelButton - Mostrar botón de cancelación.
         * @param {string} title - Título de la alerta.
         * @param {string} text - Mensaje de la alerta.
         * @param {string} titleBtnConfirm - Texto para el btn de confirmar.
         * @param {string} titleBtnCancel - Texto para el btn de cancelar.
         * @param {function} onConfirm - Función a ejecutar al confirmar.
         * @param {function} onCancel - Función a ejecutar al cancelar.
         * @param {function} onDismiss - Función a ejecutar cuando se cierre el modal.
         * @returns {Promise<void>}
         * @author Fernando Claros
         */
        Vue.prototype.$alertConfirmation = function ({
            icon = 'success',
            time = 2000,
            showConfirmButton = false,
            showCancelButton = false,
            title = "",
            text = "",
            titleBtnConfirm = "Confirmar",
            titleBtnCancel = "Cancelar",
            onConfirm = null,
            onCancel = null,
            onDismiss = null,
            cancelButtonColor = '#d33',
            confirmButtonColor = "#3085d6",
        }) {
            Swal.fire({
                position: "center",
                icon,
                title,
                text,
                showConfirmButton,
                showCancelButton,
                confirmButtonText: titleBtnConfirm,
                cancelButtonText: titleBtnCancel,
                confirmButtonColor: confirmButtonColor,
                cancelButtonColor: cancelButtonColor,
                timer: (showConfirmButton || showCancelButton) ? null : time,
            }).then((result) => {
                if (result.isConfirmed) {
                    if (onConfirm && typeof onConfirm === 'function') onConfirm();
                }
                if (result.dismiss === Swal.DismissReason.cancel) {
                    if (onCancel && typeof onCancel === 'function') onCancel();
                }
                if (result.isDismissed) {
                    if (onDismiss && typeof onDismiss === 'function') onDismiss();
                }
            });
        };

        /**
         * Controlar los errores de validaciones.
         *
         * @param {object} errors
         * @returns {boolean}
         * @author Fernando Claros
         */
        Vue.prototype.$alertErrorsCallback = function (errors) {
            try {
                if ("errors" in errors && typeof errors.errors === "object") {
                    const errorsText = Object.values(errors.errors)
                        .map(
                            (item) =>
                                `<li style='font-size: 16px !important; text-align:left !important;'><i>${item}</i></li>`
                        )
                        .join("");

                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Error de validación",
                        html: `<ul style='text-align:left !important;'>${errorsText}</ul>`,
                        showConfirmButton: true,
                    });

                    return true;
                }
            } catch (e) {
                return false;
            }
            return false;
        };

        /**
         * Alerta que incluye mensaje en formato html.
         *
         * @param {string} title - Título de la alerta
         * @param {string} messageHtml - Mensaje html de la alerta.
         * @param {integer} time - Tiempo de la alerta.
         * @param {string} confirmButton - Botón de confirmación.
         * @param {string} icon - success, warning, error, info
         * @returns {Promise<void>}
         * @author Paul Valencia
         */
        Vue.prototype.$alertWithHtml = function (
            title = "¡Muy bien!",
            messageHtml,
            time = 2000,
            confirmButton = false,
            icon =  "success",
        ) {
            Swal.fire({
                position: "center",
                icon,
                title: title,
                html: messageHtml,
                showConfirmButton: confirmButton,
                timer: time,
            });
        };
    },
};

export default AlertsPlugin;
